export const BASE_URL=process.env.REACT_APP_BASE_URL
export const STRIPE_PUBLIC_KEY_LIVE=process.env.REACT_APP_STRIPE_PUBLIC_LIVE_KEY
export const STRIPE_PUBLIC_KEY_TEST=process.env.REACT_APP_STRIPE_PUBLIC_TEST_KEY
export const API=process.env.REACT_APP_API
export const SAVED_IMAGES=process.env.REACT_APP_SAVED_IMAGES
export const API_URL=`${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API}`